import type { CatalogFeatureId } from '@weavix/models/src/packaging/feature-catalog';
import { idProp, model, Model, prop } from '../../mobx-weavix';

/** A record on `account/{accountId}/sync/packages`: a package definition, or the account's default (`packages`). */
@model('ProductPackageRecord')
export class ProductPackageRecord extends Model({
    id: idProp,
    accountId: prop<string>(),
    features: prop<CatalogFeatureId[]>(),
    ownerAccountId: prop<string>(),
    packages: prop<string[]>(),
}) {
}
